import { Table, TableProps, TableRowProps } from '@brainpool/components/organisms/Table/Table';
import { Button } from '@brainpool/components/atoms/Button/Button';
import { IconType, IconPosition } from '@brainpool/components/types/Button';
import { usePresignedDownload, ResourceType } from '../../hooks/usePreSignedDownload';
import { useEffect } from 'react';
import { DocumentData } from '../../types/Documents';

interface DocumentsTableProps {
  loading: boolean;
  error?: string;
  data: DocumentData[];
  caseId: string;
}

export function DocumentsTable({ loading, error, data, caseId }: DocumentsTableProps) {
  const {
    getPresignedDownloadUrl,
    loading: presignedDataLoading,
    data: presignedData,
  } = usePresignedDownload();

  useEffect(() => {
    if (presignedData?.getPreSignedDownloadUrl?.url) {
      window.open(presignedData.getPreSignedDownloadUrl.url, '_blank', 'noopener,noreferrer');
    }
  }, [presignedData]);

  const tableData: TableProps = {
    headerRows: ['File Name', 'Document Type', ''],
    data: data.map(
      ({ id, metadata }): TableRowProps => ({
        id: id,
        items: [
          { item: metadata.filename },
          { item: metadata.type },
          {
            item: (
              <Button
                icon={IconType.CloudDownload}
                variant="contained"
                iconPosition={IconPosition.After}
                onClick={() =>
                  getPresignedDownloadUrl(id, caseId || 'undefined', ResourceType.DOCUMENT)
                }
                disabled={presignedDataLoading}
                isLoading={presignedDataLoading}
                sx={{ float: 'inline-end' }}
              ></Button>
            ),
          },
        ],
      })
    ),
    loading,
    error,
  };

  return <Table {...tableData} />;
}

export default DocumentsTable;
